import React, { useRef, useEffect, useState, useCallback } from "react";
import { faCheck, faTimes, faInfoCircle, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
// import Select from 'react-select';
import { useNavigate } from 'react-router-dom'; // Import useNavigate


const NAME_REGEX = /^(?!\s*$).+/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MOBILE_REGEX = /^[0-9]{10}$/;
const PASSWORD_REGEX = /^.{6,}$/;
const REGISTER_URL = "add-sthan-user";


const ArthiksakhaAddSthanUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
    setMobile("");
  };
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [otpData, setOtpData] = useState(null); // To store second API result
  const [error, setError] = useState(null);
  const [validMobile, setValidMobile] = useState(false);
  const [validName, setValidName] = useState(false);

  const [mobileFocus, setMobileFocus] = useState(false);
  const [nameFocus, setNameFocus] = useState(false);
  const [responsibilityFocus, setResponsibilityFocus] = useState(false);
  const { auth } = useAuth();
  const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState(auth?.level_id); // default value

  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");

  const [sthanList, setSthanList] = useState([]);
  const [selectedSthanId, setSelectedSthanId] = useState("");

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  // const [success, setSuccess] = useState(false);

  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [errors, setErrors] = useState({});

  const clearFields = async () => {
    // setSelectedRole("");
    // setSelectedVibhagId("");
    // setSelectedJillaId("");
    // setSelectedArthiksakhasId("");
    setSelectedKhandId("");        // ✅ Add this line
    setSelectedMandalamId("");        // ✅ Add this line
    setSelectedSthanId("")

    setName("");
    setMobile("");
    setResponsibility("");
  };

  useEffect(() => {
    userRef.current.focus();
  }, []);


  useEffect(() => {
    const isValid = /^[0-9]{10}$/.test(mobile);
    setValidMobile(isValid);
  }, [mobile]);

  useEffect(() => {
    const isValid = /^[a-zA-Z\s]{2,}$/.test(name); // At least 2 letters, only letters & spaces
    setValidName(isValid);
  }, [name]);


  const fetchKhands = useCallback(async () => {
    if (!auth.level_id) return;

    // setLoading(true);
    // setSthans([]);
    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${auth.level_id}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        setSelectedKhandId(data[0].khand_id); // optional default
      } else {
        setSelectedKhandId("");
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    }
    // finally {
    //   setLoading(false);
    // }
  }, [axiosPrivate, auth.level_id]);

  useEffect(() => {
    if (auth.level_id) {
      fetchKhands();
    }
  }, [auth.level_id]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        // setSthans([]); // clear table
        return;
      }

      // setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("mandals fetch failed:", err);
        setError("Failed to load mandals list");
        setMandalamList([]);
        setSelectedMandalamId("");
        // setSthans([]);
      }
      // finally {
      //   setLoading(false);
      // }
    };

    fetchMandalamList();
  }, [selectedKhandId]);



  useEffect(() => {
    const fetchSthanList = async () => {
      if (!selectedKhandId) {
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]); // clear table
        return;
      }

      // setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-sthans?mandal_id=${selectedMandalamId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setSthanList(data);
        if (data.length > 0) {
          const firstSthanId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstSthanId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]);
      }
      // finally {
      //   setLoading(false);
      // }
    };

    fetchSthanList();
  }, [selectedMandalamId]);




  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        sthan_id: selectedSthanId,
        name,
        mobile,
        responsibility,
        withotp: true
      });

      const response = await axiosPrivate.post(REGISTER_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);

      // If person_id generated, call the second API
      // const personId = response?.data?.data?.person_id;
      clearFields();
      setOtpData(response?.data); // store second API result to display
      // if (personId) {
      //   const otpResponse = await axiosPrivate.get(`get-sthan-user-otp?person_id=${personId}`);
      //   console.log("otpResponse.data" + otpResponse.data)
      //   setOtpData(otpResponse.data); // store second API result to display
      // }

    } catch (err) {
      console.log(data);
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }

  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  return (
    <>
      <Container>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}

        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>


        <section className="userregbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>

          {otpData && (
            <div className="otp-info">
              <h4>OTP Details</h4>
              {/* <p><strong>Mobile:</strong> {otpData.mobile}</p> */}
              <p className="otp-big"><strong>OTP : {otpData.otp}</strong></p>
              <p className="otp-small"><strong>Expiry :</strong> {otpData.expiry}</p>
            </div>
          )}


          <div className="wrapper wrapper2 newraps">
            <form>
              <center><h4 class=" newraphead">Add Sthan User</h4></center>
              <Row>
                <Col md={6}>
                  <Form.Label className="newformstyle">Select Khand</Form.Label>
                  <Form.Select
                    className="newselectstyle form-control guruselect"
                    value={selectedKhandId}
                    // onChange={(e) => setSelectedKhandId(e.target.value)}
                    // disabled={!khandList.length}
                    onChange={(e) => {
                      setSelectedKhandId(e.target.value);

                      setErrors((prev) => ({
                        ...prev,
                        khand: "",
                      }));
                      setOtpData("");
                      setSelectedMandalamId("");
                    }}
                    disabled={!khandList.length}

                  >
                    <option value="">-- Select Khand --</option>
                    {khandList.map((k) => (
                      <option key={k.khand_id} value={k.khand_id}>
                        {k.khand_name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <Col md={6}>
                  <Form.Label className="newformstyle">Mandalam</Form.Label>
                  <Form.Select
                    className="newselectstyle form-control guruselect"
                    value={selectedMandalamId}
                    // onChange={(e) => {
                    //   const mandalamId = e.target.value;
                    //   setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID
                    // }}
                    onChange={(e) => {
                      const mandalamId = e.target.value;
                      setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID

                      setErrors((prev) => ({
                        ...prev,
                        mandalam: "",
                      }));

                      setSelectedSthanId("");
                      setOtpData("");
                    }}
                    disabled={!mandalamList.length}
                  >

                    <option value="">-- Select Mandalam --</option>
                    {mandalamList.map((m) => (
                      <option key={m.mandal_id} value={m.mandal_id}>
                        {m.mandal_name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>


                <Col md={6}>
                  <Form.Label className="newformstyle">Sthan</Form.Label>
                  <Form.Select
                    className="newselectstyle form-control guruselect"
                    value={selectedSthanId}
                    // onChange={(e) => {
                    //   const sthanId = e.target.value;
                    //   setSelectedSthanId(sthanId); // Correctly set Mandalam ID
                    // }}
                    onChange={(e) => {
                      const sthanId = e.target.value;
                      setSelectedSthanId(sthanId); // Correctly set Mandalam ID

                      setOtpData("");
                      setErrors((prev) => ({
                        ...prev,
                        sthan: "",
                      }));
                    }}
                    disabled={!sthanList.length}
                  >

                    <option value="">-- Select Sthan --</option>
                    {sthanList.map((m) => (
                      <option key={m.sthan_id} value={m.sthan_id}>
                        {m.sthan_name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>


                <Col md={6}>
                  <div className="input-box arthik_input-box"><br />
                    <input
                      type="text"
                      id="name"
                      className="newinpstyle"
                      placeholder="Enter Name"
                      autoComplete="off"
                      ref={userRef}
                      // onChange={(e) => setName(e.target.value.replace(/[^a-zA-Z\s]/g, ""))}
                      onChange={(e) => {
                        setName(e.target.value.replace(/[^a-zA-Z\s]/g, ""));
                        setOtpData("");
                        setErrors((prev) => ({
                          ...prev,
                          name: "",
                        }));
                      }}
                      value={name}
                      required
                      aria-invalid={validName ? "false" : "true"}
                      aria-describedby="namenote"
                    />

                    <small
                      className={
                        name && !validName
                          ? "text-danger mt-1 d-block"
                          : "d-none"
                      }
                    >
                      Name must contain only letters and be at least 2 characters long.
                    </small>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="input-box arthik_input-box"><br />
                    <input
                      type="text"
                      id="mobile"
                      className="newinpstyle"
                      placeholder="Enter Mobile number"
                      autoComplete="off"
                      ref={userRef}
                      // onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                      onChange={(e) => {
                        setMobile(e.target.value.replace(/\D/g, ""));
                        setOtpData("");
                        setErrors((prev) => ({
                          ...prev,
                          mobile: "",
                        }));
                      }}
                      value={mobile}
                      required
                      aria-invalid={validMobile ? "false" : "true"}
                      aria-describedby="mobilenote"
                      maxLength={10}
                    />

                    <small
                      className={
                        mobile && !validMobile
                          ? "text-danger mt-1 d-block"
                          : "d-none"
                      }
                    >
                      Mobile number must be 10 digits!.
                    </small>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="input-box arthik_input-box"><br />
                    <input
                      type="text"
                      id="responsibility"
                      className="newinpstyle"
                      placeholder="Enter Responsibility"
                      autoComplete="off"
                      onChange={(e) => setResponsibility(e.target.value)}
                      value={responsibility}
                      required
                      aria-describedby="responsibilitynote"
                      onFocus={() => setResponsibilityFocus(true)}
                      onBlur={() => setResponsibilityFocus(false)}
                    />
                  </div>
                </Col>
              </Row><br />
              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={handleSubmit} // Call this for "Sign Up"
                disabled={!validMobile
                  || !validName
                  || !validName
                  || !selectedKhandId
                  || !selectedMandalamId
                  || !selectedSthanId
                }
              >
                Create User
              </button>
            </form>

          </div>
        </section>
        {/* )} */}
      </Container>
    </>
  );
};

export default ArthiksakhaAddSthanUser;
